module.exports = __webpack_public_path__ + "img/iekichimap20210315.63f3478f.jpg";